import React, { useEffect, useState } from "react";
import { CheckCircle, Building2, ArrowRight, Calendar } from "lucide-react";

const URL_RDV = "https://groupe-lbs.fr/contact/";
const REDIRECT_URL = "https://groupe-lbs.fr";

const ConfirmationScreen = ({ result }) => {
  const [countdown, setCountdown] = useState(10);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      window.location.assign(REDIRECT_URL);
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown]);

  if (!result) return null;

  return (
    <div className="screen-container justify-center">
      <div
        className="content-wrapper"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(20px)",
          transition: "opacity 0.5s ease, transform 0.5s ease",
        }}
      >
        {/* Main card */}
        <div className="card p-8 text-center mb-4">
          {/* Check icon */}
          <div className="flex justify-center mb-5">
            <div
              style={{
                width: 84,
                height: 84,
                borderRadius: "50%",
                backgroundColor: "#E8F5E9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircle size={44} color="#2E7D32" />
            </div>
          </div>

          <h2
            style={{
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              fontSize: 22,
              color: "#12354D",
              marginBottom: 8,
            }}
          >
            Rapport envoyé !
          </h2>

          <p
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              color: "#4A4A4A",
              lineHeight: 1.6,
              marginBottom: 20,
            }}
          >
            Votre diagnostic a été envoyé par email avec votre rapport PDF
            personnalisé en pièce jointe.
          </p>

          {/* Agency block */}
          <div
            style={{
              backgroundColor: "#F7F4F0",
              borderRadius: 12,
              padding: "16px 20px",
              textAlign: "left",
              marginBottom: 24,
            }}
          >
            <div className="flex items-center gap-3 mb-2">
              <Building2 size={18} color="#12354D" />
              <p
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 700,
                  fontSize: 14,
                  color: "#12354D",
                }}
              >
                {result.agency_name}
              </p>
            </div>
            <p
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: 12,
                color: "#6B7280",
                lineHeight: 1.5,
              }}
            >
              {result.agency_contact}
            </p>
          </div>

          {/* CTA button */}
          <a
            data-testid="rdv-button"
            href={URL_RDV}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              width: "100%",
              padding: "16px",
              backgroundColor: "#B5163A",
              color: "white",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 600,
              fontSize: 15,
              borderRadius: 12,
              textDecoration: "none",
              marginBottom: 12,
              boxSizing: "border-box",
              transition: "filter 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.12)")}
            onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
          >
            Réserver mon Audit 360°
            <ArrowRight size={18} />
          </a>

          {/* Countdown */}
          <div
            className="flex items-center justify-center gap-2"
            style={{ color: "#9CA3AF" }}
          >
            <Calendar size={12} />
            <span style={{ fontSize: 12, fontFamily: "Inter, sans-serif" }}>
              Redirection dans {countdown} seconde{countdown !== 1 ? "s" : ""}...
            </span>
          </div>
        </div>

        <p
          style={{
            color: "rgba(255,255,255,0.3)",
            fontSize: 12,
            textAlign: "center",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Groupe LBS Conecti — Solutions Numériques
        </p>
      </div>
    </div>
  );
};

export default ConfirmationScreen;
